module.exports = __webpack_public_path__ + "static/media/abattoir-picture-1.477e8f86.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Themes/Abattoir/abattoir-picture-1.jpg
// module id = 62
// module chunks = 0